export const temporaryTranslations = {
  LBLI0222:
    "Please let us know the reason for the cancellation so we can improve our services.",
  LBLI0223: "I found a better deal",
  LBLI0224: "Signal coverage is poor",
  LBLI0225: "Data speed is too low",
  LBLI0226: "SIM is not working",
  LBLI0227: "Other",
};
